import React, { FC, ReactNode, useEffect } from 'react';
import classNames from 'classnames';

import Headline from '@sv-support-sdk/ui-components/src/components/Typography/Headline';

import Button from '../../Controls/Button';

import useMobileDetect from '../../../hooks/useMobileDetect';

import css from './style.module.scss';
import setQaAttribute from '../../../helpers/setQaAttribute';

interface IProps {
  title?: string;
  children: ReactNode;
  align?: 'center';
  className?: string;
  headerClassName?: string;
  onCloseClick?: () => void;
  type?: 'sidebar' | 'mobile';
  qaId?: string;
}

const Modal: FC<IProps> = ({
  title,
  children,
  align,
  className,
  onCloseClick,
  type,
  headerClassName,
  qaId,
}) => {
  const isMobile = useMobileDetect();

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onCloseClick?.();
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [onCloseClick]);

  return (
    <div
      className={classNames(
        css.modal,
        {
          [css[`modal_align_${align}`]]: align,
          [css[`modal_type_${type}`]]: type,
        },
        className,
      )}
      {...setQaAttribute(qaId)}
    >
      <div className={classNames(css.modal__header, headerClassName)}>
        {title && <Headline type={isMobile ? undefined : 'secondary'}>{title}</Headline>}
        <div className={css.modal__action}>
          <Button
            onClick={onCloseClick}
            iconSize="24"
            icon="24--close"
            variant="transparent"
            shape="square"
          />
        </div>
      </div>
      {children}
    </div>
  );
};

export default Modal;
